

// export const API_URL = "https://www.staging.adminv2.talentlitmus.com";
export const API_URL = 'https://api.adminv2.talentlitmus.com';

export const baseGameUrlSchneider = 'https://schneidergames.talentlitmus.com';

export const baseGameUrlGeneral = 'https://games.talentlitmus.com';

export const baseGameUrlValuesGame = 'https://valuesgame.talentlitmus.com/murugappagame';


export const SJT_ID_BEFORE_SCORE = '61b98b6c31ccf10011fbf16e';

export const urlsStart = {
  JumblesGame: 'jumbles',
  SJTGame: 'sjt',
  ClassificationGame: 'classification',
  MatchColumnGame: 'mtc',
  OrderingsGames: 'ordering',
  QuestionsGame: 'questions',
  WheelSpinGame:'wheelspin'
};

// const linkType = getGameLinkType();

// class GameURLS {
//   linkType = linkType;
//   startScreen(currentTile) {
//     return `https://games.talentlitmus.com/startscreen${this.linkType}?currTile=${currentTile}`;
//   }
// }
